import { Node_Type } from '@wix/ricos';

export const PLACEHOLDER_RICH_CONTENT = {
  nodes: [
    {
      id: '',
      nodes: [
        {
          id: '',
          nodes: [],
          type: Node_Type.TEXT,
          textData: {
            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            decorations: [],
          },
        },
      ],
      type: Node_Type.PARAGRAPH,
    },
  ],
};
